import "./Weddings.module.css";
import Header from "@/reusable_sections/Header";
import UnRicordoPerSempre from "./sections/UnRicordoPerSempre";
import LoffertaWedding from "./sections/LoffertaWedding";
import RichiediUnPreventivo from "./sections/RichiediUnPreventivo";
import Footer from "@/reusable_sections/Footer";
export default function WeddingsPage() {
  return <div>
      <Header />
      <UnRicordoPerSempre />
      <LoffertaWedding />
      <RichiediUnPreventivo />
      <Footer />
    </div>;
}